import { AppType, isValidAppType } from "../../../api/models";
import { appInfo } from "../../../authConfig";

/**
 * Determines AppType based on user context
 */
export const getAppTypeBasedOnUser = (appType: string): string => {
    const appTypeBasedOnUser = appType === "ALL" ? (appInfo?.use_all_tab === true ? "ALL" : "FAQ") : appType;

    return appTypeBasedOnUser;
};

/**
 * Validates and returns appropriate AppType
 */
export const getValidAppType = (appType: string): AppType => {
    if (appType === "ALL" && appInfo?.use_all_tab !== true) {
        return "FAQ";
    }
    return isValidAppType(appType) ? (appType as AppType) : appInfo.use_all_tab === true ? "ALL" : "FAQ";
};

/**
 * Updates AppType in session storage
 */
export const updateAppTypeValueInSessionStorage = (appType: AppType): void => {
    sessionStorage.setItem("appType", appType);
};

/**
 * Answer key helper for app types
 */
export const answerKeyFor = (appType: AppType): "FAQ" | "Manuals" | "ALL" => {
    return appType === "FAQ" ? "FAQ" : appType === "ALL" ? "ALL" : "Manuals";
};
